/**
 * Messaging Service
 * @author PBirudukota
 * @description Used to communicate between the components
 */
import {Injectable} from '@angular/core';
import {Observable, Subject, BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MessagesService {

  constructor() {
  }

  private backgroundSubject = new Subject<any>();
  private logoSubject = new Subject<any>();
  private reviewSubject = new BehaviorSubject<any>('');
  private validationSubject = new BehaviorSubject<object>({});
  private docSubject = new BehaviorSubject<any>('');


  sendValidationData(data:object){
    this.validationSubject.next(data);
  }

  getValidationData(){
    return this.validationSubject.asObservable();
  }
  sendDocData(data:object){
    this.docSubject.next(data);
  }

  getDocData(){
    return this.docSubject.asObservable();
  }

  sendReviewData(data:object){
    this.reviewSubject.next(data);
  }

  getReviewData(){
    return this.reviewSubject.asObservable();
  }

  sendBGMessage(message: string) {
    this.backgroundSubject.next({text: message});
  }

  clearBGMessage() {
    this.backgroundSubject.next();
  }

  getBGMessage(): Observable<any> {
    return this.backgroundSubject.asObservable();
  }

  sendLogoMessage(message: string) {
    this.logoSubject.next({text: message});
  }

  clearLogoMessage() {
    this.logoSubject.next();
  }

  getLogoMessage(): Observable<any> {
    return this.logoSubject.asObservable();
  }

  sendConfMessage(message: string) {
    this.logoSubject.next({text: message});
  }

  clearConfMessage() {
    this.logoSubject.next();
  }

  getConfMessage(): Observable<any> {
    return this.logoSubject.asObservable();
  }
}
